// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__o8_Hs","selected":"Chip_selected__1JbRW"};